// jobInfoSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { JobInfo, RevisedJobInfo } from './types'

interface JobInfoState {
    jobInfo: JobInfo | null
}

const initialState: JobInfoState = {
    jobInfo: null,
}

const jobInfoSlice = createSlice({
    name: 'jobInfo',
    initialState,
    reducers: {
        setJobInformation(state, action: PayloadAction<JobInfo>) {
            state.jobInfo = action.payload
        },
        updateJobInformation(state, action: PayloadAction<Partial<JobInfo>>) {
            if (state.jobInfo) {
                state.jobInfo = {
                    ...state.jobInfo,
                    ...action.payload,
                }
            }
        },
        addRevisedJobInfo(state, action: PayloadAction<RevisedJobInfo>) {
            if (state.jobInfo) {
                state.jobInfo.revisedJobInfo = [
                    ...state.jobInfo.revisedJobInfo,
                    action.payload,
                ]
            }
        },
    },
})

export const { setJobInformation, updateJobInformation, addRevisedJobInfo } =
    jobInfoSlice.actions

export default jobInfoSlice.reducer
